import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-camera-field',
  templateUrl: './camera-field.component.html',
  styleUrls: ['./camera-field.component.scss'],
})
export class CameraFieldComponent {
  @Input() disabled: boolean = false;
  @Input() required: boolean = false;
  @Input() image?: string;
  @Output() imageChange = new EventEmitter<string>();

  onChange(files: FileList) {
    if (files && files[0]) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.image = e.target?.result as string;
        this.imageChange.emit(this.image);
      };
      reader.readAsDataURL(files[0]);
    }
  }
}
